import {
  InstallmentBody,
  InstallmentDuration,
  InstallmentProgram,
  InstallmentQuery,
} from "@interfaces/installment"
import { Result } from "@lib/api/services/response"
import InstallmentRepository from "../repositories/installment.repository"

export default class InstallmentServices extends InstallmentRepository {
  async getInstallmentData(query: Partial<InstallmentQuery>) {
    try {
      const res = await this.getRawInstallmentList(query)

      if (res.ok) {
        const result = await this._getRawResult<InstallmentDuration[] | InstallmentProgram[]>(res)

        return Result.ok<InstallmentDuration[] | InstallmentProgram[]>(result)
      } else {
        return Result.fail<InstallmentDuration[] | InstallmentProgram[]>()
      }
    } catch (error: any) {
      return Result.fail<InstallmentDuration[] | InstallmentProgram[]>()
    }
  }

  async submitInstallmentData(body: InstallmentBody) {
    try {
      const res = await this.submitRawInstallment(body)

      if (res.ok) {
        const result = await this._getRawResult<any>(res)

        return Result.ok<any>(result)
      } else {
        return Result.fail<any>()
      }
    } catch (error: any) {
      return Result.fail<any>()
    }
  }
}
